__turbopack_context__.v({
  "active": "HeaderButtons-module-scss-module__TJNEsq__active",
  "dropDownContainer": "HeaderButtons-module-scss-module__TJNEsq__dropDownContainer",
  "dropDownList": "HeaderButtons-module-scss-module__TJNEsq__dropDownList",
  "dropdownLink": "HeaderButtons-module-scss-module__TJNEsq__dropdownLink",
  "headerBar": "HeaderButtons-module-scss-module__TJNEsq__headerBar",
  "headerBarTrans__iconwrapper": "HeaderButtons-module-scss-module__TJNEsq__headerBarTrans__iconwrapper",
  "headerBarWhite__button": "HeaderButtons-module-scss-module__TJNEsq__headerBarWhite__button",
  "headerBarWhite__iconwrapper": "HeaderButtons-module-scss-module__TJNEsq__headerBarWhite__iconwrapper",
  "headerBarWhite__order": "HeaderButtons-module-scss-module__TJNEsq__headerBarWhite__order",
  "headerBar__addGap": "HeaderButtons-module-scss-module__TJNEsq__headerBar__addGap",
  "headerBar__button": "HeaderButtons-module-scss-module__TJNEsq__headerBar__button",
  "headerBar__heart": "HeaderButtons-module-scss-module__TJNEsq__headerBar__heart",
  "headerBar__iconwrapper": "HeaderButtons-module-scss-module__TJNEsq__headerBar__iconwrapper",
  "headerBar__iconwrapper__favor": "HeaderButtons-module-scss-module__TJNEsq__headerBar__iconwrapper__favor",
  "headerBar__order": "HeaderButtons-module-scss-module__TJNEsq__headerBar__order",
  "headerBar__profile": "HeaderButtons-module-scss-module__TJNEsq__headerBar__profile",
  "headerBar__select": "HeaderButtons-module-scss-module__TJNEsq__headerBar__select",
  "headerBar__zeroGap": "HeaderButtons-module-scss-module__TJNEsq__headerBar__zeroGap",
  "headerDropDownButton": "HeaderButtons-module-scss-module__TJNEsq__headerDropDownButton",
  "link": "HeaderButtons-module-scss-module__TJNEsq__link",
  "link__profile": "HeaderButtons-module-scss-module__TJNEsq__link__profile",
  "searchFlatDisabled": "HeaderButtons-module-scss-module__TJNEsq__searchFlatDisabled",
  "svgArrows": "HeaderButtons-module-scss-module__TJNEsq__svgArrows",
  "visualDropDown": "HeaderButtons-module-scss-module__TJNEsq__visualDropDown",
});
